export const formatTitle = (title: string) => title.replace(' pallets', '')
